import comp from "./SpinnerLoader";
export default comp;
